import Vue from 'vue';
import Cookie from "js-cookie";
// import router from '@/router/index';

export default {
  auth(to, from, next) {
    if (!Cookie.get("token")) next("/login");

    let nameRouter = [true, 'true'].includes(Cookie.get("is_construtora")) ? '/construtora/home' : '/home';

    let passDefault = [true, 'true'].includes(Cookie.get("primeiro_acesso"));
    let isXRM = [true, 'true'].includes(Cookie.get("integracao_xrm"));

    if ((passDefault && isXRM) && !['home', 'perfil'].includes(to.name) && ![true, 'true'].includes(Cookie.get("is_construtora"))) {
      Vue.toasted.info("<b>Ops!</b>&nbsp;&nbsp;Você ainda não atualizou sua senha. Atualize-a agora para desbloquear o acesso à página desejada.");
      next(nameRouter);
      return;
    }

    // const matchedRoute = router.options.routes.find(route => route.path === to.path);
    
    // if (!matchedRoute) {
    //   Vue.toasted.error("<b>Ops!</b>&nbsp;&nbsp;Esta rota não existe.");
    //   next(nameRouter);
    //   return;
    // }

    if ([true, 'true'].includes(Cookie.get("is_construtora")) && !['construtora'].includes(to.meta?.can)) {
      Vue.toasted.info("<b>Ops!</b>&nbsp;&nbsp;Você não tem permissão para acessar essa página.");
      next(nameRouter);
      return;
    }

    if ([false, 'false'].includes(Cookie.get("is_construtora")) && ['construtora'].includes(to.meta?.can)) {
      Vue.toasted.info("<b>Ops!</b>&nbsp;&nbsp;Você não tem permissão para acessar essa página!");
      next(nameRouter);
      return;
    }

    next();
  },

  unauthentic(to, from, next) {
    if (!Cookie.get("token")) next("/login");

    let nameRouter = Cookie.get("is_construtora") ? '/construtora/home' : '/home';
    next(nameRouter);
  },

  authCustom(to, from, next) {
    if (Cookie.get("token")) {

      let nameRouter = Cookie.get("is_construtora") ? '/construtora/home' : '/home';
      next(nameRouter);
    }

    next();
  },
}
